import { Drawer } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import ProjectCreateUpdateComponent from '../../components/projects/ProjectCreateUpdateComponent';
import SelectAddressModal from '../../components/auth/SelectAddressModal';

import { Project, createProjectAsync } from '../../modules/projects';
import { getProjectConfig } from '../../api/constlink';

interface ProjectCreateDrawerProps {
  visibleDrawer: boolean;
  enterpriseId: string;
  onClose: () => void;
}

function ProjectCreateDrawer({
  visibleDrawer,
  enterpriseId,
  onClose,
}: ProjectCreateDrawerProps) {
  const dispatch = useDispatch();
  const [projectLocation, setProjectLocation] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);
  const [projectConfig, setProjectConfig] = useState();

  useEffect(() => {
    if (!visibleDrawer) return;
    (async () => {
      const _projectConfig = await getProjectConfig({ enterpriseId });
      setProjectConfig({ ..._projectConfig });
    })();
  }, [enterpriseId, visibleDrawer]);

  const onCreate = (project: Project) => {
    const tempProject = {
      ...project,
      startDate:
        project.startDate === ''
          ? ''
          : moment(project.startDate).format('YYYY-MM-DD'),
      endDate:
        project.endDate === ''
          ? ''
          : moment(project.endDate).format('YYYY-MM-DD'),
    };
    dispatch(
      createProjectAsync.request({ enterpriseId, project: tempProject }),
    );
    onClose();
    setProjectLocation('');
  };
  const onCancel = () => {
    onClose();
  };

  const selectAddressModalOnCancel = () => setVisible(false);
  const openSelectAddressModal = () => setVisible(true);

  const selectAddress = (value: any) => {
    setProjectLocation(value.address);
    setVisible(false);
  };

  return (
    <>
      {
        <Drawer
          width={600}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visibleDrawer}
        >
          {visibleDrawer && projectConfig && (
            <ProjectCreateUpdateComponent
              projectLocation={projectLocation}
              projectConfig={projectConfig}
              onCreate={onCreate}
              onCancel={onCancel}
              openSelectAddressModal={openSelectAddressModal}
            />
          )}
          {visible && (
            <SelectAddressModal
              selectAddress={selectAddress}
              onCancel={selectAddressModalOnCancel}
              visible={visible}
            />
          )}
        </Drawer>
      }
    </>
  );
}

export default ProjectCreateDrawer;
